
import React from 'react';

const PageNotFound = () => {
    return (
        <div style={{ marginTop: "15rem", fontSize: "35px" }}>
            <h1 style={{ marginLeft: "55rem", fontWeight: "bold", fontSize: "55px" }}>404 Error</h1>
            <h1 style={{ fontSize: "45px", marginLeft: "52rem" }}>Page Not Found</h1>
        </div>
    );
}

export default PageNotFound;